import React, { useEffect, useState } from 'react';

import { ReactComponent as ArrowIcon } from '@repo/common/assets/icons/26px/icon_26px_arrow.svg';
import { getAdminBookingStats } from '../../../api/booking/booking.api';

const HeaderItem = ({
  label,
  greenLabel,
  totalAmount,
  percentage,
  count,
  isDisabled,
}) => {
  return (
    <div
      className={`flex flex-col items-start min-h-[120px] tabletV:min-h-[160px] w-full h-full px-5 py-4 tabletV:px-[30px] tabletV:py-6 gap-3 tabletV:gap-4 rounded-[15px] bg-grayscale-gray00`}
    >
      <div className='flex items-start gap-2 w-full'>
        <span className='typo-b13 text-text-secondary w-full'>{label}</span>
        <button className={`${isDisabled ? 'text-grayscale-gray02' : ''}`}>
          <ArrowIcon />
        </button>
      </div>

      <div className='flex flex-col justify-end items-start gap-1 w-full flex-1'>
        <div className='typo-b14Strong text-green-deep02'>
          {percentage || count} {greenLabel}
        </div>
        <div className='typo-title1 text-grayscale-gray09'>{totalAmount}</div>
      </div>
    </div>
  );
};

const WorkshopNavTabBar = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const data = await getAdminBookingStats();
        setStats(data);
      } catch (error) {
        console.error('Failed to fetch dashboard stats:', error);
      }
    };

    fetchStats();
  }, []);

  const attendanceRate = stats
    ? Math.round((stats.attendedCount / (stats.confirmedCount || 1)) * 100)
    : 0;

  return (
    // 폰 1열 → 태블릿 2열 → tabletV 4열
    <div className='grid grid-cols-1 mobile:grid-cols-2 tabletV:grid-cols-4 w-full items-stretch gap-3 tabletH:gap-6 pb-8 tabletV:pb-[60px]'>
      <HeaderItem
        isDisabled
        label='Revenue (This Month)'
        percentage={stats ? `${stats.changePercent ?? 0}%` : '-'}
        greenLabel='from last month'
        totalAmount={
          stats
            ? `${stats.thisMonthTotal} $${
                Number(stats.thisMonthTotalKrw || 0) > 0
                  ? ` · ${Math.round(Number(stats.thisMonthTotalKrw)).toLocaleString('en-US')} KRW`
                  : ''
              }`
            : '-'
        }
      />
      <HeaderItem
        isDisabled
        label='Total Bookings'
        greenLabel='Excludes cancellations'
        totalAmount={stats ? stats.confirmedCount + stats.attendedCount : '-'}
      />
      <HeaderItem
        isDisabled
        label='Checked-in (Attendance rate)'
        greenLabel={`${attendanceRate}%`}
        totalAmount={stats ? stats.attendedCount : '-'}
      />
      <HeaderItem
        isDisabled
        label='Cancellations & Absents'
        count={stats ? stats.refundedCount : '-'}
        greenLabel={'refunds pending'}
        totalAmount={stats ? stats.cancelledCount : '-'}
      />
    </div>
  );
};

export default WorkshopNavTabBar;
